<i18n src="@/locales/modules/UserSettingsTranslate.json"></i18n>

<template>
	<div>
		<div class="text-center pt-10">

			<vs-avatar :src="avatar" size="100px" class="mr-4 mb-1" />
			<p class="font-bold mb-1">{{ name }}</p>
			<p class="font-normal mb-6">{{ email }}</p>
			<p class="font-semibold" style="color: rgba(0, 0, 0, 0.50);">Chọn vai trò hoạt động</p>
		</div>

		<div class="mt-8 role-container">
			<div  @click="changeActive(role.employee_id)" class="role-box flex flex-row items-center" :key="indextr" v-for="(role, indextr) in roles" :style="{cursor: 'pointer', border: activeEmployee == role.employee_id ? '2px solid #2B59B2' : '2px solid rgba(0, 0, 0, 0.25)'}">
				<vs-radio :vs-name="'vs_r'+role.employee_id" v-model="activeEmployee" :vs-value="role.employee_id"></vs-radio>
				<div>
					<div style="width: 2px; height: 95%; min-height: 134px; border-radius: 41px; background: #F2F2F2; margin-left: 10px; margin-right: 20px;"></div>
				</div>
				<div>
					<p class="font-bold mb-3" style="text-transform: uppercase; font-size: 14px">{{ role.cluster_name }}</p>
					<p class="font-semibold mb-3" style="color: rgba(0, 0, 0, 0.50); font-size: 12px;">Thông tin</p>
					<p class="font-bold mb-1" style="color: #000000; font-size: 14px">{{ role.title_name }}</p>
					<p class="font-bold" style="color: #2B59B2; font-size: 12px;">{{ role.department_name }}</p>
				</div>
			</div>

			<vs-button class="font-bold mt-8 whitespace-no-wrap" @click.stop="changeRole">Xác nhận</vs-button>
		</div>

	</div>
</template>

<script>

import * as _ from "lodash";
export default {
	components: {
		
	},
	data() {
		return {
			username: "johny_01",
			name: this.$store.state.AppActiveUser.role.name,
			email: this.$store.state.AppActiveUser.login,
			avatar: this.$store.state.AppActiveUser.role.avatar,
			roles: [],
			activeEmployee: 0,

		};
	},
	computed: {
		isSmallerScreen() {
			return this.$store.state.windowWidth < 768;
		}
	},
	methods: {
		changeActive(id) {
			this.activeEmployee = id;
		},
		async changeRole() {
			try {
				this.$vs.loading();
				let userLocal = _.cloneDeep(this.$store.state.AppActiveUser );
				if (userLocal.employee_id != this.activeEmployee) {
					const response = await fetch(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+'/custom-api/change-role', {
						method: 'POST',
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({eid: this.activeEmployee}),
						});
					const user = await response.json();
					if (user && user.token) {
						localStorage.setItem("accessToken", user.token);
						if (user.employee) {
							userLocal.role = user.employee;
							userLocal.id = user.id;
							userLocal.employee_id = user.employee_id;
							userLocal.cluster_id = user.cluster_id;
							localStorage.setItem("userInfo", JSON.stringify(userLocal));
						}
					}
				}
				window.location = '/app';
			} catch (error) {
				console.error(error);
			} finally {
				this.$vs.loading.close();
			}
		},
		async fetchRoles() {
			try {
				let activeEmployee = localStorage.getItem("activeEmployee");
				if (!activeEmployee) {
					activeEmployee = this.$store.state.AppActiveUser.employee_id;
				}
				this.$vs.loading();
				const response = await fetch(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+'/custom-api/employee-roles?eid='+activeEmployee);
				const roles = await response.json();
				if (roles && roles.roles) {
					this.roles = roles.roles;
					console.log(this.roles)
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.$vs.loading.close();
			}
		}
	},
	created() {
		try {
			let activeEmployee = localStorage.getItem("activeEmployee");
			if (!activeEmployee) {
				activeEmployee = this.$store.state.AppActiveUser.employee_id;
				localStorage.setItem("activeEmployee", activeEmployee);
			}
			this.activeEmployee = this.$store.state.AppActiveUser.employee_id;
		} catch (exx) {
			console.log(exx.message);
		}
		this.fetchRoles();
	}
};
</script>

<style lang="scss">
.role-container {
	display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.role-box {
	border-radius: 5px;
	border: 2px solid #2B59B2;
	background: #FFF;
	box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
	padding: 10px 20px;
	min-width: 550px;
	margin-bottom: 15px;
}
</style>
